import React, { useState, useEffect } from 'react';
import axios from 'axios';
import MaskedInput from 'react-text-mask'
import { MdPhoneInTalk } from 'react-icons/md';
import { mobilePattern } from '../../Investment/UtilityComponents/UtilityFunction';


const TalkExperts = (props) => {
    const [isSubmit, setSubmit] = useState(false);
    const [mobileNumber, setMobileNumber] = useState("");
    const [errors, setErrors] = useState({});
    const [isMobileFocused, setIsMobileFocused] = useState(false);

    useEffect(() => {
        if (props.mobile) {
            setMobileNumber(props.mobile);
        }
    }, [props.mobile])

    const maskMobileNumber = (value) => {
        if (!value) return "";
        const digits = value.replace(/\D/g, "");
        if (digits.length <= 4) { return digits; }
        // Example: 9876543210 -> ******3210 
        return `${"*".repeat(digits.length - 4)}${digits.slice(-4)}`;
    };
    function getCallBack() {
        const error = {};
        let goto = true;
        if (!mobileNumber) {
            goto = false;
            error['mobileNumber'] = "Please enter valid mobile number";
        } else if (mobileNumber !== null) {
            if (mobileNumber.length < 10) {
                goto = false;
                error["mobileNumber"] = "Entered mobile number should be of 10 digits"
            }
            else if (mobileNumber === "9999999999" || mobileNumber === "8888888888" || mobileNumber === "7777777777" || mobileNumber === "6666666666") {
                goto = false;
                error["mobileNumber"] = "Please enter valid mobile number"
            } else if (mobilePattern.test(mobileNumber)) {
                goto = false;
                error["mobileNumber"] = "First 6 digits cannot be all the same"
            }
        }
        setErrors(error);
        if (goto) {
            const Model = {
                "MobileNo": mobileNumber,
                "InterestedIn": props.EnquiryTypeList,
                "NextCallTime": ""
            }
            const req = {
                URL: 'MobileCallBack',
                Req:Model
            }
            axios.post('central/centralcall/callreqwithheader', req).then((response) => {
                    setSubmit(true)
                    //console.log(response);
                });
        }
    }
    //console.log(props.mobile);
    return (
        <div className="mobileBox">
            <div className="MobilDigitBox">
                <div className="CallExperts text-center">
                    {isSubmit ?
                        <div className="CallExperts_Succeessfully">
                            <div className="CallExperts_wrap">
                                <button><MdPhoneInTalk /></button>
                            </div>
                            <h3>We have received your request. We will call you soon!</h3>
                            <small>(Operational timings: 10 AM-6 PM)</small>
                            <p>or </p>
                            <p className="TollFreeNumber">call us (Toll Free) 1800 2666 3666</p>
                        </div>
                        :
                        <>
                            <p><strong>Talk to an expert</strong></p>
                            {/* <h1 className="TalkThanksMsg">
                                You can also reach us directly at these toll-free numbers:
                            </h1>*/}
                            <label id="talkInput">
                                {/*<MaskedInput
                                    type="tel"
                                    mask={[/[6-9]/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/]}
                                    guide={false} showMask={false}
                                    placeholder=""
                                    value={mobileNumber}
                                    maxLength="10"
                                    onChange={(e) => setMobileNumber(e.target.value)  }
                                />*/}
                                {isMobileFocused ? (
                                    <MaskedInput type="tel"
                                        mask={[/[6-9]/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/]}
                                        guide={false} showMask={false}
                                        placeholder="" value={mobileNumber}
                                        maxLength={10}
                                        onChange={(e) => {
                                            setMobileNumber(e.target.value);
                                            setErrors({});
                                        }}
                                        onBlur={() => setIsMobileFocused(false)}
                                        onFocus={() => setIsMobileFocused(true)}
                                        autoFocus />
                                ) : (
                                        <input type="tel"
                                            value={maskMobileNumber(mobileNumber)}
                                            placeholder=""
                                            readOnly

                                            onFocus={() =>
                                            setIsMobileFocused(true)} />)}

                                <div className="mobilDigit">+91</div>
                                <div className="mobilDigitIcon"><i className="fas fa-mobile-alt"></i></div>
                                <span className="Error-Text">{errors["mobileNumber"]}</span>
                            </label>
                            <button type="button" className="SMCSmall" id="talktoexpertsBtn" onClick={getCallBack}><i class="fas fa-phone-alt"></i> Talk to an expert</button>
                            <p className="TollFreeNumber"> You can also reach us directly (Toll Free) <a href="tel:1800 2666 3666"> <i class="fas fa-phone-alt ms-1"></i> 1800 2666 3666</a></p>
                        </>
                    }

                </div>
            </div>
        </div>
    );
}

export default TalkExperts